<template>
    <menu>
        <div class="center">
            <ul>
                <li v-for="item in menu" :key="item.id">
                    <route-item class="menu__link" :to="item.route" :element="item.element" @click.native="toogleMenu(item.route)">
                        {{item.name}}
                    </route-item>
                </li>
            </ul>
        </div>
    </menu>
</template>

<script>
    import Form from '@/components/common/Form';
    import Helpers from '@/tools/Helpers';

    export default {
        name: 'Menu',
        data(){
            return {
                menu: [
                    {
                        id: 0,
                        name: 'О проекте',
                        route: '/',
                        element: 'index',
                        gaEvent: 'index'
                    },
                    {
                        id: 1,
                        name: 'Путешествие',
                        route: '/main',
                        element: 'main',
                        gaEvent: 'main'
                    },
                    {
                        id: 2,
                        name: 'Места силы',
                        route: '/point1',
                        element: 'point1',
                        gaEvent: 'point1'
                    },
                    {
                        id: 3,
                        name: 'Пора на пикник!',
                        route: '/picnic',
                        element: 'picnic',
                        gaEvent: 'picnic'
                    }
                ],
                showForm: true
            }
        },
        components:{
            Form
        },
        methods: {
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },

            toogleMenu(route){
                this.$emit('closeMenu');

                this.gaEvents('menu','click',route)
            },
            close() {
                this.showForm = false
            }
        }
    }
</script>

<style>

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

</style>


// WEBPACK FOOTER //
// Menu.vue?b03c3578